/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import RocketIcon from "images/rocket.svg";

const modalStyle = {
  overlay: {
    zIndex: 50,
    backgroundColor: "#00000080", // black with a bit of transparency
  },
  content: {
    position: "absolute",
    zIndex: 100,
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    background: "transparent",
    overflow: "hidden",
    borderRadius: "10px",
    border: "none",
    padding: "none",
    outline: "none",
    transform: "translate(-50%, -50%)",
    maxWidth: "564px",
    boxShadow:
      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  },
};

export const AccountExistModal = ({
  closeModal,
  isOpen,
  email,
}) => {

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Account Exists Modal"
      style={modalStyle}
      ariaHideApp={false}
    >

      <div className="w-full h-full bg-white text-black flex flex-col fade rounded-md" style={{ minWidth: 350 }}>
        <div className="p-8">
          <div className="flex justify-between">
            <span className="text-2xl font-bold">Welcome Back!</span>
            <span
              className="text-black cursor-pointer text-4xl leading-none"
              onClick={closeModal}
            >
              &times;
            </span>
          </div>
          <div className="mt-4">Looks like there is already an account linked with this email.</div>
          <div className="mt-4 flex gap-4 flex-row">
            <button
              type="button"
              onClick={() => {
                window.location.href = `/dashboard/login${email ? `?email=${encodeURIComponent(email)}` : ""}`;
              }}
              className="px-4 py-[6px] text-white bg-black hover:bg-neutral-600 active:bg-boost-neutral-700 font-medium hover:font-medium text-center rounded-md flex-shrink-0"
            >
              Log in
            </button>
            <button
              type="button"
              onClick={closeModal}
              className="px-4 py-[6px] bg-white border border-neutral-400 hover:bg-neutral-200 active:bg-neutral-300 font-medium hover:font-medium text-center rounded-md flex-shrink-0"
            >
              Cancel
            </button>
          </div>
        </div>
        <div className="bg-boost-primary-50 px-8 py-3 flex justify-between items-end">
          <div className="text-base align-text-bottom">
            <img src={RocketIcon} alt="" className=" inline-flex mr-2" />
            <span className="font-bold mr-2">New:</span>
            Boost your credit with TomoBoost

          </div>
          <Link
            to="/boost"
            className="underline hover:no-underline whitespace-nowrap"
          >
            Learn more
          </Link>
        </div>
      </div>
    </Modal>
  );
};
